import React from 'react';
import { View, StyleSheet } from 'react-native';
import { radii } from '../../domain/tokens';
import { KyrsTool } from '../../tools/KyrsTool';
import type { OrderWidgetProps } from './types';

// The DIRECTIONS section's KYRS entry mounts the FULL native KYRS app
// (src/tools/KyrsTool.tsx — the faithful rebuild of web's My Lists overview
// + long list-detail view, PAGE/DOWN/OUT navigation, add/edit/complete/
// reorder, auto-scheduler, trash, verification bell) rather than a capped
// mini snippet. `userId`/`data`/`onOpen` from OrderWidgetProps aren't needed
// here — KyrsTool reads auth itself (useAuth) and is fully self-contained —
// but the OrderWidgetProps contract is kept so ORDER section wiring in
// SyqiHome.tsx doesn't need to special-case this widget.
export function KyrsWidget(_props: OrderWidgetProps) {
  return (
    <View style={styles.wrap}>
      <KyrsTool sector="S" stage="T" gear="direct" />
    </View>
  );
}

const styles = StyleSheet.create({
  // A concrete (not min-height-only) height is required here: KyrsTool's
  // root View is `flex: 1` and its internal ScrollViews are `flex: 1` too —
  // both need a definite ancestor height to size against, which a bare
  // ScrollView content container (SyqiHome's outer dashboard scroller)
  // never provides on its own. 560 is generous — a full screen's worth of
  // the long detail view — while still letting KyrsTool's own internal
  // ScrollViews (overview rows / long-view task rows) own their scroll
  // gesture inside that bounded box, instead of fighting the outer
  // dashboard scroller for it.
  wrap: {
    height: 560,
    borderRadius: radii.tile,
    overflow: 'hidden',
  },
});
